<footer class="app-footer" [class.app-footer--auth]="variant() === 'auth'" *transloco="let t">
  <div class="app-footer__links">
    <a routerLink="/consents/document/terms-of-service">{{ t('footer.terms') }}</a>
    <span class="app-footer__separator">·</span>
    <a routerLink="/consents/document/privacy-policy">{{ t('footer.privacyPolicy') }}</a>
    <span class="app-footer__separator">·</span>
    <a routerLink="/consents/document/cookie-policy">{{ t('footer.cookiePolicy') }}</a>
  </div>
  <span class="app-footer__copyright">© {{ currentYear }} {{ t('common.appName') }}</span>
</footer>
